import styled from 'styled-components';

export const Content = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  color: #000;
  padding: 10px 15px 10px 28px;
  z-index: 9;
  box-shadow: 0 -2px 10px 2px rgba(204, 204, 204, 0.8);
  border-top: 1px solid #ccc;
`;

export const Inner = styled.div`
  display: flex;
  align-items: center;
`;

export const Clear = styled.div`
  margin: 0 10px 0 0;
  button {
    width: 30px;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
    i,
    img {
      margin: 0;
    }
  }
`;

export const Selected = styled.div`
  margin: 0 15px 0 0;
  min-width: 130px;
`;

export const ForAll = styled.div`
  margin-left: 15px;
  display: flex;
  align-items: center;
  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    input {
      margin: 0;
    }
    span {
      margin-left: 7px;
    }
  }
`;
